import React from 'react'
import Styled from 'styled-components'
import { graphql, StaticQuery, Link } from 'gatsby'
import utils from './../../../scripts/utils'

import componentsData from '../../../data/components-data'

const camelToSpaced = utils.camelToSpaced

class Sidebar extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <StaticQuery
            query={graphql`query {
                allMarkdownRemark(sort: { fields: [frontmatter___order], order: ASC }) {
                  edges {
                    node {
                      frontmatter {
                        title
                      }
                      fields {
                        slug
                      }
                    }
                  }
                }
              }`}
              render={data => (
                <SidebarWrapper className={(this.props.state ? 'visible' : 'hidden')}>
                    <section>
                        {data.allMarkdownRemark.edges.map((item, idx) => {
                          const pathItems = item.node.fields.slug.split('/')
                          pathItems.splice(pathItems.length - 1, 1)
                          const slug = pathItems.pop()
                          return <SidebarLink activeClassName="active" to={slug} key={idx}>{item.node.frontmatter.title}</SidebarLink>

                        })}
                    </section>

                    <section>
                        <SectionTitle>Components</SectionTitle>

                        {componentsData.map((item, idx) => {
                            return <SidebarLink activeClassName="active" to={item.slug} key={idx}>{camelToSpaced(item.name)}</SidebarLink>
                        })}
                    </section>
                </SidebarWrapper>
              )} />
        )
    }
}

export default Sidebar

const SidebarWrapper = Styled.aside`
    position: fixed;
    background: #fff;
    height: calc(100vh - 70px);
    width: 250px;
    border-right: 1px solid #e9e8f1;
    float: left;
    box-shadow: inset -1px 0 3px rgba(0,0,0,.05);
    z-index: 1;
    padding: 10px 0;
    overflow-y: scroll;

    a {
        text-decoration: none !important;
    }

    @media (max-width: 780px) {
        transform: translateX(-250px);
        box-shadow: none;
        border: none;
        transition: transform .15s ease-in-out;

        &.visible {
            transform: translateX(0);
            box-shadow: 3px 0 30px rgba(17,31,93,.08),
                        2px 0 5px rgba(27,27,43,.09);
        }
    }
`

const SidebarLink = Styled(Link)`
    color: #515f6b;
    display: flex;
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
    line-height: 1;
    will-change: box-shadow,color;
    font-weight: 400;
    transition: box-shadow .25s ease-in-out,color .25s ease-in-out;

    &.active {
        color: #2858fe;
        box-shadow: inset 3px 0 0 #2858fe;
        background: linear-gradient(-135deg,hsla(0,0%,100%,0),#dfe3ff);
    }
`

const SectionTitle = Styled.h4`
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 1px;
    color: #8a93a5;
    border-top: 1px solid #e9e8f1;
    padding: 10px 20px 0;
    margin: 10px 0 0;
`
